const SIGNAL_NAME_MAP = {
  signal_atm: "ATM",
  signal_exchange_mlrisk_high: "High-Risk Exchange",
  signal_exchange_mlrisk_low: "Low-Risk Exchange",
  signal_exchange_mlrisk_moderate: "Moderate-Risk Exchange",
  signal_exchange_mlrisk_veryhigh: "Very High-Risk Exchange",
  signal_ico: "ICO",
  signal_illicit_actor_org: "Illicit actor-organisation",
  signal_nft_platform_collection: "NFT Platform - Collection",
  signal_p2p_exchange: "P2P Exchange",
  signal_p2p_exchange_mlrisk_high: "High-Risk P2P Exchange",
  signal_p2p_exchange_mlrisk_low: "Low-Risk P2P Exchange",
  signal_payment: "Payment Management",
  signal_risky_exchange: "Exchange | High Risk",
  signal_special_measures: "Special Measures",
} as const;

export { SIGNAL_NAME_MAP };
